import axios from "axios";

export default {
  sendMessage: (data) => {
    return axios
      .post(`/api/v1/contact/message`, data)
      .then((response) => response.data.data);
  },
};
